<template>
  <v-autocomplete
    v-bind="$attrs"
    v-model="serviceCenter"
    :items="serviceCenterOptions"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    auto-select-first
    :item-text="itemDisplay"
    :label="label"
    :prepend-icon="mdiDatabaseSearch"
    return-object no-filter
    :error-messages="errorMessages"
    clearable
    v-on:click:clear="clear"
    change
    hide-details
    :inputmode="inputmode"
  ></v-autocomplete>
</template>

<script>
import {mdiDatabaseSearch} from "@mdi/js";
import debounce from 'lodash/debounce'
import isEmpty from 'lodash/isEmpty'
import { SelectServiceCenter, GetDefaultServiceCenter } from "@/api/publicServices";
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    cachedServiceCenters: {
      type: Array
    },
    errorMessages: {
      type:String
    },
    onChange: {
      type:Function
    }
  },
  data: () => ({
    serviceCenterOptions: [{
      CenterNo: '',
      Name: ''
    }],
    isLoading: false,
    search: null,
    serviceCenter: {
      CenterNo: '',
      Name: ''
    },
    isClear: false,

    //svg icons
    mdiDatabaseSearch,
  }),
  mounted() {
    this.getDefault();
  },
  computed: {
    inputmode() {
      return  localStorage.getItem("flutter") == "true" || this.$isMobile()?"none":"text";
    },
  },
  created: function() {
    this.debouncedSearchServiceCenter = debounce(this.searchServiceCenter, 500);
    this.debouncedFilterCachedServiceCenter = debounce(this.filterCachedServiceCenters, 500);
  },
  methods: {
    async getDefault() {
      try {
        const response = await GetDefaultServiceCenter();
        this.serviceCenter = response.data.ORIGIN_WAREHOUSE;
      } catch (error) {
        console.log(error);
      }
    },
    async searchServiceCenter(searchVal) {
      if (this.isClear) {
        this.isClear = false;
        return;
      }
      if (this.isLoading) return;
      if (searchVal != '' && !isEmpty(this.serviceCenter) && this.serviceCenter.Name === searchVal) return;
      this.isLoading = true;
      try {
        const response = await SelectServiceCenter({ "CenterType" :"ORIGIN_WAREHOUSE", "SearchVal": searchVal});
        console.log(`response:${response}`);
        this.isLoading = false;
        this.serviceCenterOptions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    setWarehouse(location) {
      this.serviceCenter = location;
    },
    getWarehouse() {
      return this.serviceCenter;
    },
    filterCachedServiceCenters(searchVal) {
      if (this.isLoading) return;
      if (searchVal.length === 0) return;
      const searchText = searchVal.toLowerCase();
      this.serviceCenterOptions = this.cachedServiceCenters.filter(serviceCenter => {
        return serviceCenter.Name.toLowerCase().indexOf(searchText) > -1;
      });
      this.isLoading = false;
    },
    itemDisplay: item=>(item==null)?"":item.Name,
    clear() {
      this.isClear = true;
      console.log("isClear");
    },
  },
  watch: {
    search(newVal) {
      if (this.cachedServiceCenters && this.cachedServiceCenters.length > 0) {
        this.debouncedFilterCachedServiceCenter(newVal);
      } else {
        this.debouncedSearchServiceCenter(newVal);
      }
    },
    serviceCenter() {
      this.$emit("input", this.serviceCenter);
    }
  }
};
</script>